import React, { useState, useEffect } from 'react'
import { createUseStyles, useTheme } from 'react-jss'
import { HiOutlineSearch } from 'react-icons/hi'

import View from '../form/View'
import Header from '../form/Header'
import Item from '../form/Item'
import InputField from '../form/InputField'
import Footer from '../form/Footer'

const useStyles = createUseStyles(theme => ({
  root: {
    flexDirection: 'column',
    flex: 1,
  },
  subtitle: {
    fontFamily: 'Fira Sans, sans serif',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '18px',
    color: theme.colors.primary,
    marginBottom: '24px'
  },
  searchBar: {
    flexDirection: 'column',
    margin: '0 36px'
  },
  listView: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    overflowY: 'auto',
    margin: '0 36px 12px'
  }
}))

function ResponsibleStep (props) {
  
  const theme = useTheme()
  const styles = useStyles({ ...props, theme })
  const [ filter, setFilter ] = useState(null)
  const [ list, setList ] = useState(props.responsibles)
  const [ selected, setSelected ] = useState(props.initialData ? props.initialData.responsible : null)

  useEffect(() => {
    if (filter && filter.trim()) {

      const filteredList = props.responsibles.filter(responsible => {
        return responsible.name.toUpperCase().includes(filter.toUpperCase());
      });

      setList(filteredList)

    } else {
      setList(props.responsibles)
    }
  }, [ filter, props.responsibles ])

  const onNext = () => {
    const responsible = selected !== 'unknown' ? selected : undefined
    props.next({ responsible })
  }

  return (
    <View className={styles.root}>
      <Header 
        title={props.msg} 
        index={props.index} 
        numOfSteps={props.numOfSteps} 
        showMarkers={true}
      />
      <View className={styles.searchBar}>
        <div className={styles.subtitle}>
          {props.question}
        </div>
        <InputField 
          placeholder="Busque pelo nome"
          onChange={e => setFilter(e.target.value)}
          icon={<HiOutlineSearch />}
        />
      </View>
      <View className={styles.listView}>
        { props.noOptionMsg &&
          <Item 
            key={'unknown'}
            label={props.noOptionMsg}
            onSelect={() => setSelected('unknown')}
            selected={selected === 'unknown'}
          />
        }
        { list.map((responsible) => (
          <Item 
            key={responsible.email}
            label={responsible.name}
            onSelect={() => setSelected(responsible.email)}
            selected={selected === responsible.email}
          />
        ))}
      </View>
      <Footer 
        onBack={() => props.back()}
        onNext={onNext}
        disabled={!selected}
      />
    </View>
  )
}

export default ResponsibleStep